import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  bestDealProductReducer,
  categoryReducer,
  groupCategoryListReducer,
  groupListReducer,
  groupProductListReducer,
  productCreateReviewReducer,
  productDetailsReducer,
  productListReducer,
  searchListReducer,
} from "./Reducers/ProductReducers";
import { cartReducer } from "./Reducers/CartReducers";
import {
  otpReducer,
  userDetailsReducer,
  userLoginReducer,
  userRegisterReducer,
  userUpdateProfileReducer,
} from "./Reducers/userReducers";
import {
  orderCODReducer,
  orderCreateReducer,
  orderDetailsReducer,
  orderListMyReducer,
  orderPayReducer,
  orderUPIReducer,
  payUPIReducer,
} from "./Reducers/OrderReducres";
import { subscriberReducer } from "./Reducers/GeneralReducers";

const reducer = combineReducers({
  productList: productListReducer,
  searchList: searchListReducer,
  productDetails: productDetailsReducer,
  productReviewCreate: productCreateReviewReducer,
  cart: cartReducer,
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  orderCreate: orderCreateReducer,
  orderDetails: orderDetailsReducer,
  orderPay: orderPayReducer,
  orderCOD: orderCODReducer,
  orderUPI: orderUPIReducer,
  payUPI: payUPIReducer,
  orderListMy: orderListMyReducer,
  subscriber:subscriberReducer,
  groupList: groupListReducer,
  groupProductList: groupProductListReducer,
  groupCategoryList: groupCategoryListReducer,

  categoryData: categoryReducer,
  otp: otpReducer,
  bestDealProductList: bestDealProductReducer,
});

const cartItemsFromLocalStorage = localStorage.getItem("cartItems")
  ? JSON.parse(localStorage.getItem("cartItems"))
  : [];

// login
const userInfoFromLocalStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

// shippingAddress
const shippingAddressFromLocalStorage = localStorage.getItem("shippingAddress")
  ? JSON.parse(localStorage.getItem("shippingAddress"))
  : {};

const initialState = {
  cart: {
    cartItems: cartItemsFromLocalStorage,
    shippingAddress: shippingAddressFromLocalStorage,
  },
  userLogin: { userInfo: userInfoFromLocalStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
